import { StyleSheet } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    picker: {
        height: 46,
        width: 250,
        color: Colors.darker,
        borderRadius: 6,
        paddingHorizontal: Layout.gutter,
        paddingBottom: 2,
        borderColor: Colors.border,
        fontSize: 14
    }
});
